import FacebookIcon from "../assets/socialNetworks/facebook.svg?react";
//import InstagramIcon from "../assets/socialNetworks/instagram.svg?react";
//import LinkedInIcon from "../assets/socialNetworks/linkedin.svg?react";
import MailIcon from "../assets/socialNetworks/mail.svg?react";

import FacebookIconWhite from "../assets/socialNetworks/facebook-white.svg?react";
import MailIconWhite from "../assets/socialNetworks/mail-white.svg?react";

export const socialNetworks = [
  {
    name: "Facebook",
    url: "https://www.facebook.com/bpckrusevac",
    icon: <FacebookIcon />,
    iconWhite: <FacebookIconWhite />,
  },
  /*  {
    name: "Instagram",
    url: "",
    icon: <InstagramIcon />,
  },
  {
    name: "LinkedIn",
    url: "",
    icon: <LinkedInIcon />,
  },*/
  {
    name: "LinkedIn",
    url: "mailto:office@bpcproject.com",
    icon: <MailIcon />,
    iconWhite: <MailIconWhite />,
  },
];
